import { ThirdAuthUser, VerifyAction, Web3WalletType } from './auth.interface';
import { BaseInterface } from './base.interface';
import { UserSetting } from './settings.interface';

export type FaValidatorType = 'Email' | 'Mobile' | 'None';

/**
 * 用户基本信息
 */
export interface AccountInforData extends BaseInterface {
  /**头像地址 */
  avater: string;
  /**是否绑定谷歌验证码 */
  isBindGoogleValid: boolean;
  /**是否绑定手机 */
  isBindMobile: boolean;
  /**最后一次登录IP */
  lastLoginIp: string;
  /**最近一次登录时间（时间戳） */
  lastLoginTime: string;
  /**手机号码 */
  mobile: string;
  /**uid */
  uid: string;
  /**用户名 */
  userName: string;
  /**手机区号 */
  areaCode: string;
  /**是否开启提款白名单 */
  hasWhiteList: boolean;
  /** 用户注册 ISO  */
  mobileRegionCode: string;
  /**邮箱 */
  email: string;
  /**地址 */
  address: string;
  /** 第三方 跳过没有密码 */
  hasPassword: boolean;
  /** 是否绑定邮箱 */
  isBindEmail: boolean;
  /** 是否是 vip */
  isVip: boolean;
  /** 是否是 svip */
  isSVip: boolean;
  /** 是否是被推薦人 */
  isMA: boolean;
  /** vip 等级 */
  viPGrade: number;
  /** KYC 等级 */
  kycGrade?: 'KycPrimary' | 'KycIntermediat' | 'KycAdvanced';
  /** Kyc 认证的姓名 */
  kycName?: string;
  /** 是否強制要求完成 KYC */
  isForceKyc?: boolean;
  userSetting: UserSetting;
  /** 用于中级 后区分 用户是否为 亚洲 或者 欧洲用户 */
  isEurope: boolean;
  /** 最后游玩游戏的分类 */
  lastGameCategory: string;
  /** 聊天访问令牌 */
  chatAccessToken: string;
  /** 社交账号绑定的邮箱 */
  socialEmail: string;
  /** 最近一次存款方式 */
  depositMode: DepositMode;
}

export interface VerifyBindMobileData extends BaseInterface {
  data: string;
  message: any;
  success: boolean;
}

export interface GoogleValidCodeData extends BaseInterface {
  manualEntryKey: string;
  qrCodeUrl: string;
}

/** 安全账户社交 list的idea */
export type TSocialUserType = keyof typeof ThirdAuthUser;
export type SocialData = {
  /** socialUserId 社交账号id */
  socialUserId: string | null;
  /** socialUserType 社交媒体类型 */
  socialUserType: TSocialUserType;
  /** socialUserName 社交媒体名字 */
  socialUserName: string | null;
  /** 是否已经绑定社交媒体 */
  isBinded: boolean;
};

export type ExtendedSocialUserType =
  | SocialData['socialUserType']
  | 'QQ'
  | 'WeChat'
  | 'Weibo'
  | 'CoinbaseWallet'
  | 'Facebook'
  | 'X'
  | 'WalletConnect'
  | 'TonConnect';

export type UserSocialDataList = Omit<SocialData, 'socialUserType'> & {
  socialUserType: ExtendedSocialUserType;
  isWeb3: boolean;
};

export type UserSocailInfo = {
  areaCode: string | null;
  mobile: string | null;
  socialInfoList: UserSocialDataList[];
};

/** 用户社交账号绑定信息 */
export interface SocialListData extends BaseInterface {
  /** 用户社交媒体信息 */
  socialInfoList: Array<SocialData>;
}

/** 解绑邮箱参数 */
export interface DisableEmailParams extends BaseInterface {
  /** 区号 */
  areaCode: string;
  /** 手机号 */
  mobile: string;
  /** 手机验证码 */
  otpCode: string;
  /** 验证类型 */
  otpType: string;
  /** 手机语言 */
  smsVoice: boolean;
  /** 邮箱验证码 */
  emailCode: string;
}

/** 绑定邮箱第二步 参数 */
export interface EnableEmailSubmit extends BaseInterface {
  uniCode: string;
  areaCode: string;
  mobile: string;
  otpCode: string;
  smsVoice: boolean;
  otpType: VerifyAction;
  password: string;
  email: string;
  emailCode: string;
}

/** 邮箱在安全中心绑定 */
export interface EnableEmailFirstParams extends BaseInterface {
  lotNumber?: string;
  captchaOutput?: string;
  passToken?: string;
  genTime?: string;
  email: string;
}

/**
 * 请求初级验证参数
 */
export interface PostPrimaryParams extends BaseInterface {
  /** 手机区号,已绑定手机则不带 未绑定手机必填 */
  areaCode?: string;
  /** 手机号,已绑定手机则不带 未绑定手机必填 */
  mobile?: string;
  /** otp码, 已绑定手机则不带 未绑定手机必填 */
  otpCode?: string;
  /** otp码,已绑定手机则不带 未绑定手机必填 */
  smsVoice: boolean;
  /** 类型 未绑定手机必填*/
  otpType: string;
  /** 国家代码 未绑定手机必填 */
  countryCode: string;
  /** 全名 必填*/
  fullName?: string;
  /** 出生日期 */
  dob?: string | '';
  /** 地址 */
  address?: string;
  /** 城市 */
  city?: string;
  /** 邮政编号 */
  zipCode?: string;
  /** 名 */
  firstName?: string;
  /** 姓 */
  lastName?: string;
}

export interface SystemConfigData extends BaseInterface {
  /**手续费类型 */
  handlingFeeType: 'A' | 'C';
}

/**
 * 綁定的Web3錢包
 */
export interface Web3ConnectedWallet {
  web3WalletType: Web3WalletType;
  network: string;
  address: string;
}

//PUBS API

export interface MemberBindSocialUserParams {
  otpType: VerifyAction;
  userType: ThirdAuthUser;
  signature?: string;
  address?: string;
  network?: string;
  key?: string;
  autoLogin?: boolean;
  clientName?: string;
  socialUserId?: string | null;
  socialUserName?: string;
  initData?: string;
  code?: string;
  state?: string;
  callBackUrl?: string;
  accessToken?: string;
  additionalProp?: {
    [key: string]: string;
  };
  friendlyAddress?: string; // 友好地址 (Ton 驗證參數)
  publicKey?: string; // (Ton 驗證參數)
  domain?: string; // 錢包回應的domain (Ton 驗證參數)
  timestamp?: number; // 錢包回應的時間戳 (Ton 驗證參數)
}
export interface VerifyBindEmailParams {
  lotNumber?: string;
  captchaOutput?: string;
  passToken?: string;
  genTime?: string;
  email?: string;
  otpType?: VerifyAction;
}

export interface VerifyBindEmailForUpdateParams {
  lotNumber?: string;
  captchaOutput?: string;
  passToken?: string;
  genTime?: string;
  email?: string;
  otpType?: VerifyAction;
  uniCode?: string;
}

export interface BindEmailForUpdateParams {
  uniCodeFromOldEmail: string;
  uniCodeFromNewEmail: string;
  otpType: VerifyAction;
  email: string;
  emailCode: string;
}
export interface BindEmailParams {
  uniCode: string;
  areaCode: string;
  mobile: string;
  otpCode: string;
  smsVoice: boolean;
  otpType: VerifyAction;
  password: string;
  email: string;
  emailCode: string;
}

export interface VerifyBindMobileParams {
  lotNumber?: string;
  captchaOutput?: string;
  passToken?: string;
  genTime?: string;
  areaCode?: string;
  mobile?: string;
  otpCode?: string;
  smsVoice: boolean;
  otpType: VerifyAction;
}

export interface BindMobileParams {
  areaCode: string;
  mobile: string;
  uniCode: string;
  otpCode: string;
  smsVoice: boolean;
  otpType: VerifyAction;
  idImgeUrls?: string[];
}

export interface VerifyBindMobileForUpdateParams {
  lotNumber?: string;
  captchaOutput?: string;
  passToken?: string;
  genTime?: string;
  areaCode?: string;
  mobile?: string;
  smsVoice: boolean;
  otpType: VerifyAction;
  uniCode?: string;
}

export interface BindMobileForUpdateParams {
  areaCode: string;
  mobile: string;
  uniCodeFromOldMobile: string;
  uniCodeFromNewMobile: string;
  otpType: VerifyAction;
  otpCode: string;
  smsVoice: boolean;
}

export interface DisconnectWalletParams {
  key: string;
  otpType: VerifyAction;
  socialUserId: string;
  userType: ExtendedSocialUserType;
}

export interface BindGoogleValidParams {
  key: string;
  otpType: VerifyAction;
  googleCode: string;
}

export interface UnBindGoogleValidParams {
  key: string;
  otpType: VerifyAction;
}

/**
 * 最近一次存款方式
 */
export enum DepositMode {
  Web3 = 'Web3',
  Transfer = 'Transfer',
  BuyCrypto = 'BuyCrypto',
}
